export var single_oplog_row = `
{{#operation_logs}}
  {{> operation_logs/_oplog_row current_tenant = ../current_tenant display_operation_log_tags = ../display_operation_log_tags}}
{{/operation_logs}}
`